export default __webpack_public_path__ + "static/media/frugalToTheOrnate.15a78f5f.png";